<template>
    <div>
        <b-container fluid>
            <h3 class="mt-3 mb-3">Route Update</h3>

            <div class="row">
                <div class="col-3">
                    <b-form-select
                        size="md"
                        v-model="route_update_obj.route"
                        :options="tracking_route_options"
                        placeholder="Route Update"
                    />
                </div>

                <div class="col-3">
                    <b-form-input
                        size="md"
                        type="text"
                        v-model="route_update_obj.tracking_number"
                        placeholder="Tracking #"
                    />
                </div>

                <div class="col-3">
                    <b-button
                        class="btn-action"
                        size="md"
                        variant="info"
                        @click="onSubmit(route_update_obj.tracking_number)"
                        :disabled="!route_update_obj.route || !route_update_obj.tracking_number"
                        >Submit</b-button
                    >

                    <b-button
                        class="btn-action ml-2"
                        size="md"
                        variant="info"
                        @click="openScanner"
                        >Scan</b-button
                    >
                </div>
            </div>

            <div class="row mt-2">
                <div class="col">
                    <b-alert
                        :show="alert_config.show"
                        :variant="alert_config.variant"
                        @dismissed="alert_config.show = false"
                        dismissible
                    >
                        {{ alert_config.message }}
                    </b-alert>
                </div>
            </div>

            <!-- <p class="decode-result mt-3">
                Last result: <b>{{ result }}</b>
            </p> -->

            <div class="row m-1" v-if="scannerOn">
                <b-button
                    block
                    class="btn-action mb-1"
                    size="md"
                    variant="danger"
                    @click="closeScanner()"
                    v-if="scannerOn"
                    >Close</b-button
                >
                <StreamBarcodeReader
                    style="width: 100%;"
                    @decode="onDecode"
                    @loaded="onLoaded"
                ></StreamBarcodeReader>
            </div>

            <h4>Scan History</h4>
            <b-table
                responsive
                small
                outlined
                striped
                hover
                sticky-header="500px"
                :items="scan_history"
                :fields="fields"
            >
            </b-table>
        </b-container>
    </div>
</template>

<script>
import moment from "moment";
import VueBarcode from "vue-barcode";
import apiService from "../services/ApiService";
import global_function from "../mixins/global_function";
import { StreamBarcodeReader } from "vue-barcode-reader";

export default {
    name: "OrderMaster",
    inject: ["API_HOST", "TABLE_LIMIT", "PAGING_LIMIT", "NODEJS_API_URL"],
    mixins: [apiService, global_function],
    components: {
        barcode: VueBarcode,
        StreamBarcodeReader
    },
    data() {
        return {
            result: null,
            route_update_obj: {
                route: null,
                tracking_number: null
            },

            scan_history: [],

            scannerOn: false,

            alert_config: {
                show: false,
                variant: "danger",
                message: ""
            },

            tracking_route_options: [],
            fields: [
                {
                    key: "date",
                    label: "Date"
                },
                {
                    key: "time",
                    label: "Time"
                },
                {
                    key: "tracking_number",
                    label: "Tracking #"
                },
                {
                    key: "order_number",
                    label: "Order #"
                },
                {
                    key: "route",
                    label: "Route"
                }
            ],

            camera_cooldown: false
        };
    },
    async created() {
        this.initialized = true;

        let routes_response = await this.getTrackingRoutes(
            this.$store.state.user_obj
        );

        // this.tracking_route_options.push({
        //     value: null,
        //     text: "-"
        // });

        for (let i in routes_response.tracking_routes) {
            this.tracking_route_options.push({
                value: routes_response.tracking_routes[i].route_name,
                text: routes_response.tracking_routes[i].route_name
            });
        }
    },
    mounted() {},
    watch: {},
    methods: {
        async onDecode(content) {
            if (this.scannerOn && !this.camera_cooldown) {
                this.result = content;
                this.onSubmit(content);
            }
        },
        onLoaded() {
            console.log("loaded barcode reader");
        },
        async onSubmit(tracking_number) {
            this.alert_config = {
                show: false,
                variant: "danger",
                message: ""
            };
            // this.scannerOn = false;
            // alert('Tracking #: '+tracking_number);

            if (!tracking_number || tracking_number === "") return;

            let response = await this.$http({
                method: "POST",
                baseURL: `${this.API_HOST}`,
                url: "route_update_scan.php",
                data: {
                    route_update_obj: {
                        ...this.route_update_obj,
                        tracking_number
                    },
                    client_id: this.$store.state.user_obj.client_id,
                    user_id: this.$store.state.user_obj.user_id
                }
            });

            this.camera_cooldown = true;
            setTimeout(() => (this.camera_cooldown = false), 2000);

            if (response.data.status === "success") {
                this.alert_config = {
                    show: true,
                    variant: "success",
                    message: "Route is updated"
                };

                this.scan_history = [
                    ...response.data.orders,
                    ...this.scan_history
                ];
            } else {
                this.alert_config = {
                    show: true,
                    variant: "danger",
                    message: `[${tracking_number}] ${response.data.message}`
                };
            }
        },
        openScanner() {
            this.scannerOn = true;
        },
        closeScanner() {
            this.scannerOn = false;
        }
    }
};
</script>

<style>
th,
td {
    white-space: nowrap;
}

.span-status {
    display: none;
}

.container-status:hover .span-status {
    display: inline;
}

.row-status_cnt {
    display: flex;
}
.scanner-container video {
    width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/RouteUpdate.vue